import React, { useMemo, useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
// @ts-expect-error no types
import { OpenLocationCode } from "open-location-code";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Fix default marker icon paths broken by Vite's asset pipeline
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

const olc = new OpenLocationCode();
const PLUS_CODE_RE = /^[A-Z0-9]{4,8}\+[A-Z0-9]{2,7}$/i;

interface PlusCodeMapProps {
  plusCode: string;
  height?: number;
}

function MapUpdater({ lat, lng }: { lat: number; lng: number }) {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], map.getZoom());
  }, [lat, lng, map]);
  return null;
}

export const PlusCodeMap: React.FC<PlusCodeMapProps> = ({
  plusCode,
  height = 250,
}) => {
  const coords = useMemo(() => {
    if (!plusCode || !PLUS_CODE_RE.test(plusCode)) return null;
    try {
      const area = olc.decode(plusCode);
      return {
        lat: area.latitudeCenter as number,
        lng: area.longitudeCenter as number,
      };
    } catch {
      return null;
    }
  }, [plusCode]);

  if (!coords) return null;

  return (
    <MapContainer
      center={[coords.lat, coords.lng]}
      zoom={15}
      style={{ height, width: "100%", borderRadius: 8 }}
      scrollWheelZoom
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[coords.lat, coords.lng]} />
      <MapUpdater lat={coords.lat} lng={coords.lng} />
    </MapContainer>
  );
};
